export default __webpack_public_path__ + "static/media/welcomeHeader.37f00232.jpg";